import { BrandKey } from '../brand/brand.interface';

const brandByHost: Record<string, BrandKey> = {
  localhost: 'telepagos',
  '127.0.0.1': 'telepagos',
  'telepagos.com.ar': 'telepagos',
  'www.telepagos.com.ar': 'telepagos',
  'plataforma.mutualpymerural.com.ar': 'pyme_rural',
  'www.plataforma.mutualpymerural.com.ar': 'pyme_rural',
  'www.plataforma.prestapp.ar': 'prestapp',
  'plataforma.prestapp.ar': 'prestapp',

  // 'app.alucerto.com.ar': 'alucerto',
  // 'marca-blanca.example.com': 'marca_blanca_generico',
};

export const environment = {
  production: true,
  nombre: null,
  url: 'https://backend.telepagos.com.ar/api/',
  urlDescarga: 'https://backend.telepagos.com.ar/',
  brandByHost,
};
